module.exports = __webpack_public_path__ + "img/405.8ac3b66f.jpg";